module.exports = __webpack_public_path__ + "static/media/xd.26e9d272.png";